export default __webpack_public_path__ + "static/media/university-of-reading.980814d3.svg";